export enum TimePeriod {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    QUARTERLY = 'quarterly',
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}